import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Newsletters$1 from '@piconetworks/pkg-field-newsletters';
import styles from '../scss/Newsletters.module.scss.js';

// type NewsletterType = 'free' | 'paid'

// type Newsletter = {
//     created_at: string
//     description: string
//     updated_at: string
//     enabled: boolean
//     id: string
//     integration_label: string
//     name: string
//     newsletter_order: number
//     type: NewsletterType
// }

// interface NewslettersBlockProps {
//     linkColor: string
//     previewMode: boolean
//     newsletters: Array<Newsletter>
// }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var NewslettersBlock = function NewslettersBlock(_ref) {
  var linkColor = _ref.linkColor,
    newsletters = _ref.newsletters,
    previewMode = _ref.previewMode;
  var selectedNewsletters = newsletters.reduce(function (acc, newsletter) {
    if (newsletter.checked) {
      acc.push(newsletter.id);
    }
    return acc;
  }, []);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("label", {
    className: styles.label
  }, "Newsletters"), /*#__PURE__*/React.createElement(Newsletters$1, {
    showMore: true,
    name: 'newsletters',
    linkColor: linkColor,
    newsletterFilter: 'preselected',
    newsletters: newsletters,
    previewMode: previewMode,
    defaultValue: selectedNewsletters
  })));
};
NewslettersBlock.displayName = 'FieldSignupNewslettersBlock';
var Newsletters = NewslettersBlock;

export { Newsletters as default };
//# sourceMappingURL=index.js.map
